import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 6a3 3 0 0 1-4.91 2.313l-5.15 3.089a3.013 3.013 0 0 1 0 1.196l5.15 3.09a3 3 0 1 1-1.03 1.715l-5.15-3.09a3 3 0 1 1 0-4.626l5.15-3.089A3 3 0 1 1 20 6z" }));
export default createSvgIcon(iconPath, "Share");
//# sourceMappingURL=ShareIcon.js.map